import React, { useEffect, useState } from 'react';

import { useConfig } from '../../../ConfigContext';
import { ProviderLink } from '../provider/ProviderLink';
import logoEgs from '../../../_assets/egs.svg';
import { Popup } from '../../../utils/Popup';
import { del, post } from '../../../utils/Request';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { RequestError } from '../../../Error.model';
import { ProviderNames } from '../ProviderEnum';

interface Props {
  showLink?: boolean;
  showUnlink?: boolean;
}
export function Egs({ showLink, showUnlink }: Props): JSX.Element {
  const config = useConfig();
  const auth = useAuth();
  const [error, setError] = useState<RequestError | null>(null);

  const link = (): void => {
    const authUrl = `https://www.epicgames.com/id/authorize?client_id=${config.serverConfig.providers.egs.clientId}`
    + '&response_type=code&scope=basic_profile&prompt=login'
    + `&redirect_uri=${location.origin}/account/egs/redirect`;

    Popup.open(authUrl, 'egs_auth');
  };

  const unlink = (): void => {
    setError(null);
    del(`${config.clientConfig.host}/players/me/unlink/providers/egs`)
      .then(() => {
        auth.getPlayer();
      }).catch((err: RequestError) => {
        setError(err);
      });
  };

  const onLinkMessage = (event: MessageEvent): void => {
    setError(null);
    if (event.data.egsData) {
      post(`${config.clientConfig.host}/players/me/link`, {
        data: {
          type: ProviderNames.EGS,
          data: {
            idToken: event.data.egsData,
          },
        },
      })
        .then(() => {
          setError(null);
          auth.getPlayer();
        })
        .catch((err: RequestError) => {
          setError(err);
        });
    }
  };

  useEffect(() => {
    window.addEventListener('message', onLinkMessage);

    return () => {
      window.removeEventListener('message', onLinkMessage);
    };
  }, []);

  return (
    <ProviderLink
      providerName={ProviderNames.EGS}
      logo={logoEgs}
      link={link}
      unlink={unlink}
      error={error}
      showLink={showLink}
      showUnlink={showUnlink}
    />
  );
}
